<h4 class="text-xl font-semibold mt-3 ml-3">
  {{ title | translate | interpolate: params }}
</h4>

@if (subtitle) {
  <p class="mb-1 mt-1 ml-3 mr-3 border-box color-light">
    {{ subtitle | translate | interpolate: params }}
  </p>
}

@if (content) {
  <p class="mb-1 mt-1 ml-3 mr-3 border-box">
    <ng-container *ngTemplateOutlet="content; context: (params ?? null)"></ng-container>
  </p>
}

<div class="flex flex-col mt-2 max-h-[80vh] overflow-y-auto">
  @for (option of options; track option; let first = $first) {
    <div
      [class.separator-top]="!first"
      [class]="option?.class ?? ''"
      (click)="onClick(option)"
      class="flex flex-row pt-4 pb-4 pl-3 pr-3 row border-box center-v"
    [ngClass]="{
    'cursor-pointer hover-highlight': !option.disabled,
    'cursor-not-allowed text-lighter': option.disabled,
    }"
      >
      @if (option?.icon) {
        <soft-icon class="mr-3" [name]="option?.icon"></soft-icon>
      }
      <span [ngClass]="option.disabled ? 'text-lighter' : 'soft-text'">{{
        option?.label | translate | interpolate: params
      }}</span>
    </div>
  }
</div>
